module.exports = __webpack_public_path__ + "img/txt.37423522.png";